export const initLoopFunctions = () => {
	initLoadMoreButton();
};

const initLoadMoreButton = () => {
	if (!document.querySelector(".load-more")) return;

	document.querySelectorAll(".load-more").forEach((button) => {
		button.addEventListener("click", function (e) {
			e.preventDefault();

			let term = this.getAttribute("data-term");
			let page = parseInt(this.getAttribute("data-page"));
			let button = this;

			let data = {
				action: "load_more_media_posts",
				term: term,
				page: page,
			};

			fetch(pp3_ajax.ajaxurl, {
				method: "POST",
				headers: {
					"Content-Type": "application/x-www-form-urlencoded",
				},
				body: new URLSearchParams(data).toString(),
			})
				.then((response) => response.text())
				.then((data) => {
					// Trim any whitespace from the data
					const trimmedData = data.trim();

					// Check if the response contains less than 6 posts
					let tempDiv = document.createElement("div");
					tempDiv.innerHTML = trimmedData;
					let postCount = tempDiv.querySelectorAll("a.youtube-thumbnail").length; // Count the number of posts

					// Append the returned posts
					if (trimmedData) {
						document.querySelector("#media-posts-" + term).insertAdjacentHTML("beforeend", trimmedData);
						button.setAttribute("data-page", page + 1);
					}

					// Hide the button if there are fewer than 6 posts returned
					if (postCount < 6) {
						button.style.display = "none"; // No more posts to load
					}
				})
				.catch((error) => {
					console.error("Error loading more posts:", error);
				});
		});
	});
};
